import React, { Component } from 'react';
import { connect } from 'react-redux';
import InlineInput from 'components/util/inlineInput';
import { baseStringActions } from 'actions/api/baseStrings';
import styles from './styles.scss';
import LodIcon from 'components/util/lodIcon';
import { openConfirmModal } from 'actions/modals';
import classnames from 'classnames';

class AddStringRow extends Component {
  constructor(props) {
    super(props);
    const { string } = props;
    this.state = {
      key: string.key,
      value: string.value,
      description: string.description || ''
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      key: newProps.string.key,
      value: newProps.string.value,
      description: newProps.string.description || ''
    });
  }

  onChange = (field, val = '') => {
    this.setState({ [field]: val });
  };

  onBlur = field => {
    const { string } = this.props;
    if (this.state[field] && this.state[field] !== string[field]) {
      this.props.dispatch(
        baseStringActions.save({
          data: {
            id: string.id,
            [field]: this.state[field]
          },
          background: true
        })
      );
    } else {
      this.setState({ [field]: string[field] });
    }
  };

  deleteString = () => {
    this.props.dispatch(
      openConfirmModal({
        text:
          'Are you sure you want to delete this string? It is not yet in production yet, so should be fine.',
        onConfirm: () => {
          this.props.dispatch(
            baseStringActions.delete({
              id: this.props.string.id,
              background: true
            })
          );
        }
      })
    );
  };

  render() {
    const { string } = this.props;

    return (
      <tr
        className={classnames(styles.wrapper, {
          [styles.locked]: string.is_deployed
        })}>
        <td className={styles.keyCell}>
          <InlineInput
            value={this.state.key}
            onChange={val => this.onChange('key', val)}
            onBlur={() => this.onBlur('key')}
            disabled={string.is_deployed || string.is_classification}
          />
        </td>
        <td>
          <InlineInput
            value={this.state.value}
            onChange={val => this.onChange('value', val)}
            onBlur={() => this.onBlur('value')}
          />
        </td>
        <td className={styles.descriptionCell}>
          <InlineInput
            value={this.state.description}
            onChange={val => this.onChange('description', val)}
            onBlur={() => this.onBlur('description')}
          />
          {!string.is_deployed && (
            <div className={styles.deleteIcon}>
              <LodIcon icon="x" onClick={this.deleteString} />
            </div>
          )}
        </td>
      </tr>
    );
  }
}

export default connect()(AddStringRow);



// WEBPACK FOOTER //
// ./src/components/dashboard/developerDashboard/addStrings/addStringRow/index.js